import React, { useCallback, useEffect, useState } from "react";
import Request from "../../components/Request";
import { Button } from "primereact/button";
import CreateRequest from "../../components/CreateReqeust";
import "./style.scss";
import { getRequests } from "../../services";
import NoRecordsFound from "../../components/NoRecordsFound";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Home = (props) => {
  const [addRequest, setAddRequest] = useState(false);
  const [requests, setRqeuest] = useState([]);
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.redux.userInfo);

  const { editable } = useSelector((state) => state.redux.userInfo);

  const loadRequests = useCallback(() => {
    getRequests().then((response) => {
      setRqeuest(response.data);
    });
  }, []);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);


  useEffect(() =>{
    if(userInfo.isAdmin){
      navigate("/home/users");
    }
  },[userInfo,navigate])

  // useEffect(() =>{
  //   if(!!meters || !meters.length){
  //     msg.current.show({ severity: 'error', detail: 'you cannot add a new requests because you don\'t have any meter', sticky: true })
  //   }
  // },[meters])

  const canAdd = () => {
    return editable;
  };

  const closeForm = (isAdded = false) => {
    setAddRequest(false);
    if (isAdded) {
      loadRequests();
    }
  };
  return (
    <React.Fragment>
      {addRequest && (
        <CreateRequest closeForm={(isAdded) => closeForm(isAdded)} />
      )}
      {!!canAdd() && (
        <div className="row justify-content-end add-request">
          <Button
            onClick={() => setAddRequest(true)}
            icon="pi pi-plus"
            iconPos="left"
            label="Add New Request"
          />
        </div>
      )}
      <div className="row my-4">
        {requests.length ? (
          requests.map((request, index) => (
            <Request
              reload={() => loadRequests()}
              key={index}
              request={request}
            />
          ))
        ) : (
          <NoRecordsFound message={"No Requests Found"} />
        )}
      </div>
    </React.Fragment>
  );
};

export default Home;
